/**
 * SEO 配置 - models (한국어)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - 플래그십 AI 비디오 생성기 | WeryAI',
        description: 'Google Veo 3.1: 네이티브 오디오와 프레임 컨트롤을 갖춘 플래그십 AI 비디오 모델.',
        keywords: 'Google Veo 3.1, 플래그십 AI 비디오, AI 비디오 생성기, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - 고품질 AI 비디오 생성 | WeryAI',
        description: 'Google Veo 3로 고품질 AI 비디오를 생성하세요. 강력한 모션 일관성과 네이티브 오디오 지원.',
        keywords: 'Veo 3, Google Veo, AI 비디오 제작, 텍스트 투 비디오, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast - 초고속 AI 비디오 생성 | WeryAI',
        description: 'Google Veo 3 Fast로 빠르게 고화질 AI 비디오를 생성하세요. 캐릭터 일관성과 초고속 렌더링 지원.',
        keywords: 'Veo 3 Fast, 초고속 AI 비디오, 캐릭터 일관성, 텍스트 투 비디오, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - 물리 시뮬레이션급 AI 비디오 생성 | WeryAI',
        description: 'OpenAI Sora 2로 물리 법칙에 부합하는 초현실적인 비디오를 생성하세요. 멀티샷 내러티브와 정밀 제어 지원.',
        keywords: 'Sora 2, OpenAI Sora, 물리 시뮬레이션, 사실적 AI 비디오, 텍스트 투 비디오, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - 플래그십 네이티브 AI 비디오 생성기 | WeryAI',
        description: 'WeryAI Video 1.0: 네이티브 멀티샷 내러티브, 스마트 이미지 투 비디오, 물리급 모션 시뮬레이션을 지원하는 플래그십 AI 비디오 모델.',
        keywords: 'WeryAI Video 1.0, WeryAI 네이티브 모델, AI 비디오 생성기, 멀티샷 내러티브, 이미지 투 비디오, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 - 스튜디오급 AI 이미지 생성기 | WeryAI',
        description: 'WeryAI Image 2.0: 탁월한 텍스트 렌더링과 초현실적 디테일을 지원하는 플래그십 AI 이미지 모델.',
        keywords: 'WeryAI Image 2.0, 스튜디오급 AI, AI 이미지 생성기, 전문 AI 디자인, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 이미지 생성기 - xAI 초현실 AI 이미지 | WeryAI',
        description: 'WeryAI에서 xAI의 Grok-2를 경험하세요. Flux.1 아키텍처 기반으로 놀라운 사실적 효과를 제공합니다.',
        keywords: 'Grok-2, xAI, Flux.1, 사실적 AI, AI 아트, WeryAI',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo - 최고급 AI 비디오 생성기 | WeryAI',
        description: 'Kling 2.5 Turbo는 탁월한 카메라 워크 제어와 감정 표현력을 제공합니다. 영화급 AI 비디오 제작의 최적 선택.',
        keywords: 'Kling 2.5 Turbo, Kling AI, 영화급 비디오, 카메라 워크 제어, 비디오 생성, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - 전문 AI 비디오 편집 및 생성 | WeryAI',
        description: 'Runway Gen-4는 심층 프롬프트 이해와 스타일 일관성을 갖추고 있습니다. WeryAI에서 차세대 AI 비디오 편집을 경험하세요.',
        keywords: 'Runway Gen-4, Runway AI, 비디오 생성기, AI 비디오 편집, 텍스트 투 비디오, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 (MiniMax) - 이커머스 및 다이나믹 AI 비디오 | WeryAI',
        description: 'Hailuo 2.3은 다이나믹 액션과 이커머스 광고에 최적화되어 있습니다. 섬세한 얼굴 미세표정과 객체 모션 제어를 제공합니다.',
        keywords: 'Hailuo 2.3, Hailuo AI, MiniMax, 이커머스 비디오, 다이나믹 AI 비디오, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI 비디오 생성기 - 고급 모션 제어 | WeryAI',
        description: 'Hailuo AI로 고급 AI 비디오를 생성하세요. 최첨단 모션 시뮬레이션과 사실적인 씬 렌더링 기능을 갖추고 있습니다.',
        keywords: 'Hailuo AI, Hailuo AI, 모션 제어, 사실적 비디오, 비디오 생성기, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - 고화질 섬세한 AI 애니메이션 생성 | WeryAI',
        description: 'WeryAI에서 Pika 2.2를 경험하고 선명하고 날카로운 고화질 AI 애니메이션을 생성하세요. 정교한 캐릭터 제작에 매우 적합합니다.',
        keywords: 'Pika 2.2, Pika AI, AI 애니메이션, 고화질 비디오, 비디오 생성기, WeryAI',
    },
    seedance: {
        title: 'Seedance AI 비디오 생성기 - 댄스 및 모션 제작 | WeryAI',
        description: 'Seedance로 사실적이고 전문적인 AI 댄스 비디오를 생성하세요.',
        keywords: 'Seedance, AI 비디오, WeryAI',
    },
    wan_2_6: {
        title: 'Wan 2.6 | Alibaba의 고급 AI 비디오 생성기 | WeryAI',
        description: 'Wan 2.6은 Alibaba의 최신 플래그십 멀티모달 AI 비디오 생성 모델로, 시네마틱 1080p 품질, 네이티브 오디오-비주얼 싱크, 스마트 멀티샷 내러티브 기능을 제공합니다. WeryAI에서 무료로 사용해보세요.',
        keywords: 'Wan 2.6, Alibaba Wan 2.6, AI 비디오 생성기, 멀티모달 비디오 모델, 텍스트에서 비디오로, 이미지에서 비디오로, 오디오 싱크, WeryAI Wan 2.6',
    },
    wan_ai: '',
    image_gpt_4o: {
        title: 'GPT-4o 이미지 생성기 - OpenAI 네이티브 이미지 AI | WeryAI',
        description: 'GPT-4o로 AI 이미지를 생성하세요. 강력한 시맨틱 이해와 고품질 시각적 출력. WeryAI에서 무료로 사용해보세요.',
        keywords: 'GPT-4o, OpenAI 이미지, AI 아트, 이미지 생성, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Google Gemini 3.0 Pro 이미지 생성 | WeryAI',
        description: '추론 기반 AI 이미지 대모델. 4K 초현실적 화질과 완벽한 텍스트 레이아웃 지원.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, AI 이미지 생성, 4K 이미지 생성, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Gemini 2.5 Flash 초고속 드로잉 | WeryAI',
        description: 'Google DeepMind가 개발한 초고속, 고일관성 AI 이미지 생성기. 자연어 편집과 다중 이미지 융합 지원.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, 초고속 드로잉, 캐릭터 일관성, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI 이미지 생성기 - 최고급 오픈소스 드로잉 대모델 | WeryAI',
        description: 'FLUX는 기존 Stable Diffusion 팀이 개발했으며, 탁월한 시각적 품질과 정확한 프롬프트 준수 능력을 제공합니다.',
        keywords: 'FLUX, Black Forest Labs, AI 드로잉, 텍스트 투 이미지, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - 전문가급 AI 드로잉 강화판 | WeryAI',
        description: 'FLUX.1 Pro와 Max 버전을 경험하세요. 더 강력한 텍스트 렌더링과 캐릭터 일관성을 갖추고 있습니다. 디자이너와 크리에이티브 전문가를 위해 설계.',
        keywords: 'FLUX Kontext, FLUX Pro, FLUX Max, 전문 드로잉, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Google 고급 텍스트 투 이미지 확산 모델 | WeryAI',
        description: '사진급, 예술적, 추상적 이미지를 생성하세요. Google Imagen 4는 다양한 스타일 제어와 고품질 렌더링을 제공합니다.',
        keywords: 'Imagen 4, Google AI 드로잉, 확산 모델, 아트 생성, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Alibaba 오픈소스 텍스트 렌더링 모델 | WeryAI',
        description: 'Alibaba Qwen Image 모델은 다국어 텍스트 렌더링과 스타일화된 창작에 집중합니다. 무료로 전문가급 비주얼 자료를 생성하세요.',
        keywords: 'Qwen Image, Tongyi Qianwen, Alibaba AI 드로잉, 다국어 텍스트, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 이미지 생성 - Alibaba 고충실도 텍스트 투 이미지 대모델 | WeryAI',
        description: 'Wan 2.5는 정확한 프롬프트 준수와 사진급 렌더링 기능을 지원합니다. Alibaba의 최신 고충실도 AI 드로잉 기술.',
        keywords: 'Wan AI, Wan 2.5, Alibaba AI 드로잉, 고충실도 이미지, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - ByteDance 배치 4K 드로잉 모델 | WeryAI',
        description: 'ByteDance가 출시한 초고속 드로잉 모델. 배치 처리와 4K 고화질 렌더링 지원. 강력한 캐릭터 일관성 제어 기능 보유.',
        keywords: 'Seedream, ByteDance AI, 배치 드로잉, 4K 이미지, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - ByteDance 올인원 AI 이미지 창작 모델 | WeryAI',
        description: 'Dreamina 4.0은 손그림 변환, 스타일 전이, 다중 캐릭터 융합을 지원합니다. ByteDance의 최고급 상용 드로잉 대모델.',
        keywords: 'Dreamina 4.0, Jimeng AI, 손그림 변환, 스타일 전이, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - ByteDance 플래그십 AI 이미지 생성 모델 | WeryAI',
        description: 'Seedream 4.5는 ByteDance의 최신 플래그십 AI 이미지 모델로, 정밀한 타이포그래피 렌더링과 다중 이미지 융합, 4K 초고화질 출력을 지원합니다. WeryAI에서 무료로 체험하세요.',
        keywords: 'Seedream 4.5, AI 이미지 생성, 타이포그래피 렌더링, 다중 이미지 융합, ByteDance, 4K 화질, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - 유연하고 섬세하며 생동감 넘치는 이미지 생성 | WeryAI',
        description: 'Midjourney는 독립 연구소 Midjourney Inc.의 최신 세대 플래그십 AI 이미지 모델입니다. WeryAI에서 무료로 체험하세요.',
        keywords: 'Midjourney, AI 이미지 생성, 예술 창작, 조명 품질, 텍스트 렌더링, 초현실적 인물, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI 비디오 생성기 - 영화급 비디오 제작 | WeryAI',
        description: 'WeryAI에서 Runway Gen-4.5를 사용하여 놀라운 비디오를 제작하세요. 자기회귀 확산 하이브리드 아키텍처로 정밀한 물리 시뮬레이션과 시간 일관성을 제공합니다.',
        keywords: 'Runway Gen-4.5, AI 비디오 생성기, 영화급 AI 비디오, 물리 시뮬레이션, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI 비디오 생성기 - 고품질 비디오 제작 | WeryAI',
        description: 'WeryAI에서 Kling 2.6 Pro를 사용하여 고품질 비디오를 생성하세요. 네이티브 오디오 비주얼 생성, 1080p 영화 품질, 우수한 프롬프트 준수 능력.',
        keywords: 'Kling 2.6 Pro, AI 비디오 생성기, 고품질 AI 비디오, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 비디오 생성기 - 정밀한 카메라 제어와 시작/끝 프레임 지원 | WeryAI',
        description: 'WeryAI에서 Dreamina 3.0(지멍 3.0)을 사용하여 영화급 AI 비디오를 생성하세요. 시작/끝 프레임 정밀 제어, 전문 카메라 워크와 1080p 고다이나믹 비디오 생성을 지원합니다.',
        keywords: 'Dreamina 3.0, 지멍3.0, AI 비디오 생성기, 카메라 제어, 시작끝 프레임 제어, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI 비디오 생성기 - 창의적 비디오 생성 | WeryAI',
        description: 'WeryAI에서 Kling O1 AI 비디오 생성기를 사용하여 창의력을 발휘하세요. 상상력이 풍부하고 독특한 비디오 콘텐츠 생성에 최적화되어 있습니다.',
        keywords: 'Kling O1, AI 비디오 생성기, 창의적 AI 비디오, Kling AI, WeryAI',
    },
}
